import React, { useEffect, useState } from "react";
import { Wrapper } from "./Status.styled";
import {
  Button,
  Table,
  Modal,
  message,
  SuccessNotification,
  Popconfirm,
} from "components/common";
import AddStatusModal from "components/pageSection/Status/AddStatusModal";
import StatusModal from "components/pageSection/Status/StatusModal";
import { callDeleteApi, callGetApi, callPostApi, callPutApi } from "utils/api";
import { getUserPermissions } from "utils/text";
import { useHistory } from "react-router";
import {
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";

const Status = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [statusData, setstatusData] = useState([]);
  const [statusName, setStatusName] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [statusCount, setStatusCount] = useState(0);
  const [editData, setEditData] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [formData, setformData] = useState({
    name: "",
    paymentTrigger: false,
    isSit: false,
    reschedule: true,
    notesRequired: true,
  });

  const columns = [
    {
      title: "Status Name",
      dataIndex: "name",
    },
    {
      title: "Payment Trigger",
      dataIndex: "paymentTrigger",
      render: (PaymentTrigger) => {
        if (PaymentTrigger) {
          return (
            <Wrapper>
              <CheckOutlined className="data-check-icon" />
            </Wrapper>
          );
        } else {
          return (
            <Wrapper>
              <CloseOutlined className="data-cross-icon" />{" "}
            </Wrapper>
          );
        }
      },
    },
    {
      title: "Action",
      render: (_, item) => (
        <a>
          {" "}
          <div>
            {getUserPermissions("edit-status-action") && (
              <EditOutlined
                onClick={() => {
                  setIsOpen(true);
                  setformData({
                    ...formData,
                    name: item?.name,
                    paymentTrigger: item?.paymentTrigger,
                  });
                  setEditData(item);
                }}
              />
            )}

            {getUserPermissions("delete-status-action") && (
              <Popconfirm
                title="Are you Sure you want to delete?"
                onConfirm={() => {
                  setDeleteId(item?._id);
                  setStatusName(item?.name);
                  deleteStatus(item?._id);
                }}
              >
                <DeleteOutlined className="delete-icon" />
              </Popconfirm>
            )}
          </div>
        </a>
      ),
    },
  ];

  const onConfirm = () => {
    setConfirm(true);
  };
  const resetFormFieldsData = () => {
    setformData({
      name: "",
      reschedule: true,
      noteymentTrigger: false,
      method: "add",
      isSit: false,
      rescsRequired: true,
    });
  }
  const GetStatusApi = () => {
    callGetApi(
      "/appointment",
      (data) => {
        setstatusData(data);
        setIsLoading(false);
      },
      (err) => {
        console.log(err);
        setIsLoading(false);
      }
    );
  };
  const callPostStatusApi = () => {
    if (formData?.name) {
      if (editData) {
        UpdateStatusApi(formData, editData?._id)
      } else {
        AddStatusApi(formData)
      }
    } else {
      message.error("Please input status name");
    }
  };
  const AddStatusApi = (data) => {
    callPostApi(
      "/appointment",
      data,
      () => {
        SuccessNotification("Status Added Successfully");
        setIsOpen(false);
        setEditData(null);
        resetFormFieldsData();
        GetStatusApi();
      },
      (err) => {
        console.log(err);
      }
    );
  }
  const UpdateStatusApi = (data, id) => {
    callPutApi(
      `/appointment/${id}`,
      data,
      () => {
        SuccessNotification("Status Updated Successfully");
        setIsOpen(false);
        setEditData(null);
        resetFormFieldsData();
        GetStatusApi();
      },
      (err) => {
        console.log(err);
      }
    );
  }
  const deleteStatus = (id) => {
    callDeleteApi(`/appointment/${id}`, (data) => {
      if (data.isDeleted) {
        SuccessNotification("Status Deleted Successfully");
        GetStatusApi();
      } else {
        onConfirm();
        setStatusCount(data.count);
      }
    }, (err) => {
      console.log(err);
    });
  };
  useEffect(() => {
    setIsLoading(true);
    GetStatusApi();
  }, []);

  return (
    <Wrapper>
      <Table
        loading={isLoading}
        columns={columns}
        header
        dataSource={statusData}
        headerTitle="Statuses"
        button
        pagination={true}
        button1={
          getUserPermissions("add-new-status-action") && (
            <Button
              title="Add New Status"
              AddIcon
              className="addButton"
              onClick={() => {
                setEditData(null);
                setIsOpen(true);
                setformData({
                  name: "",
                  reschedule: true,
                  noteymentTrigger: false,
                  isSit: false,
                  rescsRequired: true,
                });
              }}
            />
          )
        }
      />

      <Modal
        className="main-modal"
        isOpen={isOpen}
        title={editData ? "Edit New Status" : "Add New Status"}
        toggleModal={() => {
          setIsOpen(false);
        }}
        onOk={callPostStatusApi}
      >
        <AddStatusModal
          setformData={setformData}
          formData={formData}
          editData={editData}
        />
      </Modal>
      <Modal
        className="main-modal"
        isOpen={confirm}
        title={`${statusCount} Leads currently have their status set to ${statusName} .
         You must change the status of these Leads before continuing.`}
        footer={false}
        toggleModal={() => {
          setConfirm(false);
          setDeleteId("");
        }}
      >
        <StatusModal
          dataSource={statusData}
          deleteId={deleteId}
          setStatusCount={setStatusCount}
          GetStatusApi={GetStatusApi}
          setConfirm={setConfirm}
        />
      </Modal>
    </Wrapper>
  );
};

export default Status;
